import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { getIsAdmin, getLoggedInUser, getSubmitStatus } from 'reducers';
import { fetchCreditsOptions } from 'api';
import CreateCreditForm from 'components/CreateCreditForm';
import { createCredit } from 'actions/credit';
import userPage from 'decorators/userPage';
import { toast } from 'react-toastify';

class CreateCredit extends Component {
  state = {
    categories: [],
    loading: false,
  };

  componentDidMount() {
    fetchCreditsOptions()
      .then((res) => {
        const categories = res?.data?.actions?.GET?.credit_type?.choices || [];
        this.setState({
          categories,
        });
      })
      .catch(() => toast.error('Failed to load credit types'));
  }

  handleSubmit = (values) => {
    const { createCredit } = this.props;
    this.setState({ loading: true });
    return createCredit(values).finally(() => {
      this.setState({ loading: false });
    });
  };

  render() {
    const { loggedInUser, isAdmin, saveStatus } = this.props;
    const { categories, loading } = this.state;

    if (loggedInUser && !isAdmin) {
      return <Redirect to="/" />;
    }

    return (
      <div>
        <h1 className="mar-b">Create Credit</h1>
        <CreateCreditForm
          onSubmit={this.handleSubmit}
          categories={categories}
          loading={loading}
          saveStatus={saveStatus}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAdmin: getIsAdmin(state),
  loggedInUser: getLoggedInUser(state),
  saveStatus: getSubmitStatus(state, 'createCredit'),
});

const mapDispatchToProps = { createCredit };

export default userPage(
  connect(mapStateToProps, mapDispatchToProps)(CreateCredit),
);
